import React, { useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";
import {
  customerListAction,
  newWareHouseListAction
} from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import SearchField from "../forms/search-field";
import ItemsInputField from "../forms/items-input-field";
import { goodsUserTemplateAction } from "../../redux/actions/purchase-action";
import { useHotkeys } from "react-hotkeys-hook";
import SalesPurchaseTopBar from "./sales-purchase-top-bar";

const SalesPurchaseNavbar = ({
  isClone = false,
  pageType,
  pageName = "",
  currentPage = "",
  page = "",
  disabled = false,
  searchRef = {},
  name = "",
  section = "",
  importcsv = false,
  handleFileUpload = () => {},
  loading,
  tempalteArray = [],
  csvButtonText = "Import CSV",
  csvTemLoading = false,
  fetchCreditNoteFn = () => {},
  isCusInvNumRequired = true,
  clickedplus,
  autoDraft,
}) => {
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);

  const [addressPanel, setAddressPanel] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const [isToggled, setIsToggled] = useState(false);

  const navigate = useNavigate();
  const { errors, values, setFieldValue, setFieldError } = useFormikContext();
  const data = useFormikContext();
  const addressRef = useRef(null);

  const mapListToOptions = (data) => {
    return (
      data?.data?.map((item) => ({
        label: item?.warehouse_name,
        value: item?.warehouse_id, // e.g. 123
      })) || []
    );
  };
  const onListSuccess = (data) => {
    setWarehouseList(mapListToOptions(data));
    console.log("lll", data);
  };
  const onListError = (data) => {};
  useEffect(() => {
    dispatch(newWareHouseListAction(onListSuccess, onListError));
  }, []);
  const loadOptions = (inputValue, field) => {
    return new Promise((resolve) => {
      const onSuccess = (data) => {
        const options = [
          ...data.data.map((item) => ({
            value: item.cmr_id,
            label: item?.cmr_code + "-" + item?.cmr_first_name,
          })),
          {
            value: "new_customer",
            label: (
              <span className="text-primary">
                {section === "sales" ? "+ New Customer" : "+ New Vendor"}
              </span>
            ),
          },
        ];
        setLocalData(data.data);
        resolve(options);
      };

      const onError = (error) => {
        resolve([
          {
            value: "new_customer",
            label: (
              <span className="text-primary">
                {section === "sales" ? "+ New Customer" : "+ New Vendor"}
              </span>
            ),
          },
        ]);
      };

      if (inputValue?.length > 0) {
        dispatch(
          customerListAction(
            {
              field: field,
              value: inputValue,
              isVendor: section === "sales" ? true : true,
            },
            onSuccess,
            onError
          )
        );
      } else {
        resolve([]);
      }
    });
  };
  const total_amount = values.data?.reduce(
    (total, item) => total + parseFloat(item.item_total_amount || 0),
    0
  );
  useHotkeys("l", () => {
    if (addressRef.current && values?.cmr_name && pageType!=="purchase return") {
      addressRef.current.click();
    }
  });

  const handleToggle = (e) => {
    e.preventDefault();
    if (page !== "view") {
      setFieldValue("is_local_purchase", !values.is_local_purchase);
    } else return;
    // setIsToggled(!isToggled);
  };
  //${pageType!=="purchase return"?"h-[87px]":"h-auto mb-3"}
  return (
    <div>
      <SalesPurchaseTopBar
        pageType={pageType}
        page={page}
        isClone={isClone}
        autoDraft={autoDraft}
        clickedplus={clickedplus}
        name={name}
        disabled={disabled}
        loading={loading}
        csvTemLoading={csvTemLoading}
        fetchCreditNoteFn={fetchCreditNoteFn}
      />
      <div className="text-sm font-semibold">Vendor And Invoice Information</div>
      <div className={`justify-between bg-[var(--add-billing-head-bg)] border-radius flex items-center px-3 w-full py-4 my-4`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg:grid-rows-2 gap-4 w-full h-full">
        <div className="h-full grid grid-cols-[3fr_7fr] gap-3">
          <SearchField
              type="text"
              label={`${
                section === "sales"
                  ? "Customer"
                  : (values.is_local_purchase ? "Local " : "Enter ") + "Vendor"
              } Code`}
              disabled={disabled}
              menuPortalTarget={document.body}
              className="z-1 "
              isValidNewOption={true}
              autoFocus={true}
              name={"cmr_code"}
              placeholder={`${
                section === "sales" ? "Cust" : "Vendor"
              } Code`}
              onCreateOption={() => {}}
              loadOptions={(e) => loadOptions(e, "cmr_code")}
              onChange={(selectedOption, actionMeta) => {
                if (actionMeta?.action === "clear") {
                  setFieldValue("cmr_code", "");
                  setFieldValue("cmr_name", "");
                } else if (
                  selectedOption === "new_customer" ||
                  selectedOption?.value === "new_customer"
                ) {
                  //navigate("/add-customer");
                  navigate("/admin/add-customer");
                } else {
                  const customerData = localData?.find(
                    (item) => item?.cmr_id === selectedOption?.value
                  );
                  setFieldValue("cmr_code", {
                    label: customerData?.cmr_code,
                    value: customerData?.cmr_id,
                  });
                  setFieldValue("cmr_id", customerData?.cmr_id);
                  setCustomerId(customerData?.cmr_id);
                  setFieldValue(
                    "cmr_balance",
                    parseFloat(customerData?.cmr_credit_balance)
                  );
                  setFieldValue(
                    "cmr_phone_number",
                    customerData?.cmr_phone_number
                  );
                  setFieldValue("cmr_tcs", customerData?.cmr_tcs);
                  setFieldValue("cmr_tds", customerData?.cmr_tds);
                  setFieldValue("cmr_name", {
                    value: customerData?.cmr_id,
                    label: customerData?.cmr_first_name,
                  });
                  const final_total_amount =
                    Math.round(total_amount).toFixed(2);
                  const round_off_value = (
                    Math.round(total_amount) - total_amount
                  ).toFixed(2);
                  setFieldValue(`${name}_tcs_or_tds_percentage_id`, "");
                  setFieldValue(`${name}_tds_tcs_type`, "");
                  setFieldValue(`${name}_tcs_or_tds_percentage`, 0);
                  setFieldValue(`${name}_tcs_or_tds_amount`, 0);
                  setFieldValue(`${name}_round_off_value`, round_off_value);
                  setFieldValue(`${name}_total_amount`, final_total_amount);
                  if (name === "poit" || name === "gort") {
                    dispatch(
                      goodsUserTemplateAction(
                        customerData?.cmr_id,
                        (data) => {
                          const vendorTemplateData =
                            data?.data?.vendorTemplateData;
                          console.log(data, "fgdfgdfgdfgdfgdfg");
                          setFieldValue("vendorTemplate", [
                            {
                              documentType: `${vendorTemplateData?.cmr_vendor_name} - Template`,
                              expectedHeaders:
                                vendorTemplateData?.excel_columns,
                            },
                          ]);
                        },
                        () => {}
                      )
                    );
                  }

                  if (searchRef && searchRef.current) {
                    searchRef.current.focus();
                    setFieldError("cmr_name", "");
                  }
                }
              }}
            />

            <SearchField
              type="text"
              label={`${
                section === "sales"
                  ? "Customer"
                  : (values.is_local_purchase ? "Local " : "Enter ") + "Vendor"
              } Name`}
              disabled={disabled}
              menuPortalTarget={document.body}
              className="z-1 "
              isValidNewOption={true}
              autoFocus={true}
              name={"cmr_name"}
              placeholder={`Enter ${
                section === "sales" ? "Customer" : "Vendor"
              } Name`}
              onCreateOption={() => {}}
              loadOptions={(e) => loadOptions(e, "cmr_first_name")}
              onChange={(selectedOption, actionMeta) => {
                if (actionMeta?.action === "clear") {
                  setFieldValue("cmr_code", "");
                  setFieldValue("cmr_name", "");
                } else if (
                  selectedOption === "new_customer" ||
                  selectedOption?.value === "new_customer"
                ) {
                  // navigate("/add-customer");
                  navigate("/admin/add-customer");
                } else {
                  const customerData = localData?.find(
                    (item) => item?.cmr_id === selectedOption?.value
                  );
                  setFieldValue("cmr_code", {
                    label: customerData?.cmr_code,
                    value: customerData?.cmr_id,
                  });
                  setFieldValue(
                    "cmr_balance",
                    parseFloat(customerData?.cmr_credit_balance)
                  );
                  setFieldValue(
                    "cmr_phone_number",
                    customerData?.cmr_phone_number
                  );
                  setFieldValue("cmr_id", customerData?.cmr_id);
                  // setFieldValue(
                  //   "cmr_balance",
                  //   parseFloat(customerData?.cmr_open_balance)
                  // );
                  setCustomerId(customerData?.cmr_id);

                  setFieldValue("cmr_name", {
                    value: customerData?.cmr_id,
                    label: customerData?.cmr_first_name,
                  });
                  setFieldValue("cmr_tcs", customerData?.cmr_tcs);
                  setFieldValue("cmr_tds", customerData?.cmr_tds);
                  const final_total_amount =
                    Math.round(total_amount).toFixed(2);
                  const round_off_value = (
                    Math.round(total_amount) - total_amount
                  ).toFixed(2);
                  setFieldValue(`${name}_tcs_or_tds_percentage_id`, "");
                  setFieldValue(`${name}_tds_tcs_type`, "");
                  setFieldValue(`${name}_tcs_or_tds_percentage`, 0);
                  setFieldValue(`${name}_tcs_or_tds_amount`, 0);
                  setFieldValue(`${name}_round_off_value`, round_off_value);
                  setFieldValue(`${name}_total_amount`, final_total_amount);
                  if (name === "poit" || name === "gort") {
                    dispatch(
                      goodsUserTemplateAction(
                        customerData?.cmr_id,
                        (data) => {
                          const vendorTemplateData =
                            data?.data?.vendorTemplateData;
                          console.log(data, "fgdfgdfgdfgdfgdfg");
                          setFieldValue("vendorTemplate", [
                            {
                              documentType: `${vendorTemplateData?.cmr_vendor_name} - Template`,
                              expectedHeaders:
                                vendorTemplateData?.excel_columns,
                            },
                          ]);
                        },
                        () => {}
                      )
                    );
                  }

                  if (searchRef && searchRef.current) {
                    setTimeout(() => {
                      searchRef.current.focus();
                      setFieldError("cmr_name", "");
                    }, 0);
                  }
                }
              }}
            />
        </div>
        <div className="h-full">
          <ItemsInputField
            labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
            inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
            disabled={page === "view"}
            name={`${name}_gst_number`}
            label="GST Number"
            isLabelReq={true}
            placeholder="Enter GST Number"
          />
        </div>
        <div className="h-full">
          <SearchField
            type="text"
            isRequired={false}
            label="GST Type"
            disabled={disabled}
            menuPortalTarget={document.body}
            className="z-1"
            isValidNewOption={true}
            autoFocus={true}
            name={`${name}_gst_type`}
            placeholder="Select GST Type"
            onCreateOption={() => {}}
            loadOptions={(inputValue) => {
              console.log("loadOptions", inputValue);
              const options = [
                { value: "GST_1", label: "GST 1" },
                { value: "GST_2", label: "GST 2" },
                { value: "new_gst", label: "+ New GST Type" },
              ];

              // Optionally filter locally
              if (!inputValue) return Promise.resolve(options);
              const filtered = options.filter(opt =>
                String(opt.label).toLowerCase().includes(inputValue.toLowerCase()) ||
                String(opt.value).toLowerCase().includes(inputValue.toLowerCase())
              );
              return Promise.resolve(filtered);
            }}
            onChange={(selectedOption) => {
              setFieldValue(`${name}_gst_type`, {
                label: selectedOption?.label,
                value: selectedOption?.value,
              });
            }}
          />
        </div>
        <div className="h-full">
          <ItemsInputField
            labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
            inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
            disabled={page === "view"}
            name={`${name}_reference_inv_number`}
            label="Reference Invoice Number"
            isLabelReq={true}
            placeholder="Invoice Number"
          />
        </div>
        <div className="h-full">
          <ItemsInputField
            // min={moment(values[`${name}_reference_inv_date`]).format(
            //   "YYYY-MM-DD"
            // )}
            labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
            inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
            type="date"
            disabled={disabled}
            name={`${name}_document_date`}
            label="Document Date"
            isLabelReq={true}
            isRequired={true}
          />
        </div>
        <div className="h-full">
          <ItemsInputField
            // min={moment(values[`${name}_due_date`]).format(
            //   "YYYY-MM-DD"
            // )}
            labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
            inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
            type="date"
            disabled={disabled}
            name={`${name}_due_date`}
            label="Due Date"
            isLabelReq={true}
            isRequired={true}
          />
        </div>
        <div className="h-full">
          <ItemsInputField
            // min={moment(values[`${name}_document_date`]).format(
            //   "YYYY-MM-DD"
            // )}
            labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
            inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
            type="date"
            disabled={disabled}
            name={`${name}_delivery_date`}
            label={
              name === "pot"
                ? "Delivery Date"
                : section === "sales"
                ? "Delivery Date"
                : "Received Date"
            }
            isLabelReq={true}
            isRequired={true}
          />
        </div>
        <div className="h-full">
          <ItemsInputField
            // min={moment(values[`${name}_reference_inv_date`]).format(
            //   "YYYY-MM-DD"
            // )}
            labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
            inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
            type="date"
            disabled={disabled}
            name={`${name}_reference_inv_date`}
            label="Reference Invoice Date"
            isLabelReq={true}
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default SalesPurchaseNavbar;

function ToggleButton({ label = "Toggle", defaultChecked = false, onChange }) {
  const [checked, setChecked] = useState(defaultChecked);

  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        {/* Toggle Button */}
        <button
          onClick={handleToggle}
          className={`
            relative inline-flex h-8 w-14 items-center rounded-full transition-colors duration-300 ease-in-out focus:outline-none
            ${
              isToggled
                ? "bg-[var(--primary)]"
                : "bg-[var(--purchase-invoice-toggle-bg)]"
            }
          `}
          aria-pressed={isToggled}
          aria-label="Toggle button"
        >
          <span
            className={`
              inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out
              ${isToggled ? "translate-x-7" : "translate-x-1"}
            `}
          />
        </button>
      </div>
    </div>
  );
}
